module.exports = __webpack_public_path__ + "static/media/rw.af81542d.svg";